import React, { useEffect, useState, useRef } from "react";
import "../styles/nav.css";
import { motion, AnimatePresence } from "framer-motion";
import { useCookies } from "react-cookie";
import { useAudio } from "./AudioContext";
import WorksGif from "../images/works.gif";
import ExperienceGif from "../images/experience.gif";
import SkillsGif from "../images/skills.gif";
import ResumeGif from "../images/resume.gif";
import ContactGif from "../images/contact.gif";
import MilestonesGif from "../images/milestones.gif";
import SunGif from "../images/sun.gif";
import MoonGif from "../images/moon.gif";
import SystemGif from "../images/system.gif";
import McLogoFull from "../images/mclogofull.png";
import VanillaTilt from "vanilla-tilt";

export default function Nav() {
  // const [icon, setIcon] = useState("moon-stars");
  const { playAudio, playBeep, pauseBeep, playOpen } = useAudio();
  const [scrolldirection, setScrollDirection] = useState("up");
  const [scrollPos, setScrollPos] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [cookies, setCookie] = useCookies(["theme"]);
  const [theme, setTheme] = useState(cookies.theme || "dark");
  const { isMobile } = useAudio();
  const [open, setOpen] = useState(false);
  const tiltRefs = useRef([]);

  tiltRefs.current = [];

  const addToTiltRefs = (el) => {
    if (el && !tiltRefs.current.includes(el)) {
      tiltRefs.current.push(el);
    }
  };

  const handleThemeChange = (selectedTheme) => {
    playAudio();
    setTheme(selectedTheme);
    setDropdownOpen(false);
    toggleClassActive(true);
  };

  const handleOnlyThemeChange = (selectedTheme) => {
    playAudio();
    setTheme(selectedTheme);
  };

  const addClasstoNav = () => {
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 100) {
      document.querySelector(".nav").classList.add("nav-bg");
    } else {
      document.querySelector(".nav").classList.remove("nav-bg");
    }
  };

  const handleScroll = () => {
    addClasstoNav();
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > scrollPos) {
      setScrollDirection("down");
    } else {
      setScrollDirection("up");
    }
    setScrollPos(currentScrollPos);
  };

  const toggleClassActive = (removeOnly) => {
    const themebutton = document.querySelector(".theme-button");
    if (removeOnly) {
      themebutton.classList.remove("active");
      return;
    }
    themebutton.classList.toggle("active");
  };

  const applyTheme = (selectedTheme) => {
    document.documentElement.setAttribute("theme", selectedTheme);
    setCookie("theme", selectedTheme, { path: "/" });
  };

  const detectSystemTheme = () => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    } else {
      return "light";
    }
  };

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playBeep();
  };

  const handleMouseLeave = () => {
    pauseBeep();
  };

  const handleOpen = () => {
    playOpen(1);
  };

  useEffect(() => {
    const systemTheme = detectSystemTheme();
    if (theme === "system") {
      setCookie("theme", "system", { path: "/" });
      // setTheme(systemTheme);
      document.documentElement.setAttribute("theme", systemTheme);
    }
  }, [theme]);

  useEffect(() => {
    if (theme === "dark") {
      // setIcon("moon-stars");
      applyTheme(theme);
    } else if (theme === "light") {
      // setIcon("brightness");
      applyTheme(theme);
    } else {
      // setIcon("customize-computer");
    }
  }, [theme]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPos]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        toggleClassActive(true);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!cookies.theme) {
      setCookie("theme", "dark", { path: "/" });
    }
  }, []);

  useEffect(() => {
    tiltRefs.current.forEach((ref) => {
      if (ref) {
        VanillaTilt.init(ref, {
          scale: 1.1,
          max: 25,
          speed: 400,
          glare: true,
          "max-glare": 1,
        });
      }
    });
  }, []);

  return (
    <>
      <div className={`nav ${scrolldirection !== "up" ? "nav-up" : ""}`}>
        {isMobile ? (
          <i
            class="fi fi-rr-menu-burger"
            onClick={() => {
              console.log("clicked");
              setOpen(!open);
              handleClick();
            }}
          ></i>
        ) : (
          <ul>
            <a
              href="#works"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img src={WorksGif} alt="works" className="works-gif" />
                Works
              </li>
            </a>

            <a
              href="#skills"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img src={SkillsGif} alt="skills" className="skills-gif" />
                Skills
              </li>
            </a>

            <a
              href="#experience"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img
                  src={ExperienceGif}
                  alt="experience"
                  className="experience-gif"
                />
                Experience
              </li>
            </a>

            <a
              href="#resume"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img src={ResumeGif} alt="resume" className="resume-gif" />
                Resume
              </li>
            </a>

            <a
              href="#contact"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img src={ContactGif} alt="contact" className="contact-gif" />
                Contact
              </li>
            </a>

            <a
              href="#milestones"
              onClick={handleClick}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <img
                  src={MilestonesGif}
                  alt="milestones"
                  className="milestones-gif"
                />
                Milestones
              </li>
            </a>

            <div ref={dropdownRef}>
              <li
                className="theme-button"
                onClick={() => {
                  setDropdownOpen(!dropdownOpen);
                  handleOpen();
                  toggleClassActive();
                }}
              >
                {/* <i className={"fi fi-rr-" + icon + " theme-icon"}></i> {theme} */}
                {theme === "dark" && (
                  <img src={MoonGif} alt="moon" className="theme-icon" />
                )}
                {theme === "light" && (
                  <img src={SunGif} alt="sun" className="theme-icon" />
                )}
                {theme === "system" && (
                  <img src={SystemGif} alt="system" className="theme-icon" />
                )}
                {theme}
                <i className="fi fi-rr-angle-small-down down-icon"></i>
              </li>
              {/* Use AnimatePresence to wrap motion.div */}
              <AnimatePresence>
                {dropdownOpen && (
                  <motion.div
                    key="dropdown"
                    animate={{ y: 0 }}
                    initial={{ y: -10 }}
                    transition={{ duration: 0.2 }}
                    className="dropdown-content"
                  >
                    <button onClick={() => handleThemeChange("system")}>
                      System
                    </button>
                    <button onClick={() => handleThemeChange("dark")}>
                      Dark
                    </button>
                    <button onClick={() => handleThemeChange("light")}>
                      Light
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </ul>
        )}
      </div>
      {isMobile && (
        <div className={`nav mobile ${open ? "open" : ""}`}>
          <ul>
            <a
              href="#works"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img src={WorksGif} alt="works" className="works-gif" />
                  Works
                </div>
              </li>
            </a>

            <a
              href="#skills"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img src={SkillsGif} alt="skills" className="skills-gif" />
                  Skills
                </div>
              </li>
            </a>

            <a
              href="#experience"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img
                    src={ExperienceGif}
                    alt="experience"
                    className="experience-gif"
                  />
                  Experience
                </div>
              </li>
            </a>

            <a
              href="#resume"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img src={ResumeGif} alt="resume" className="resume-gif" />
                  Resume
                </div>
              </li>
            </a>

            <a
              href="#contact"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img src={ContactGif} alt="contact" className="contact-gif" />
                  Contact
                </div>
              </li>
            </a>

            <a
              href="#milestones"
              onClick={() => {
                handleClick();
                setOpen(false);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <li ref={addToTiltRefs}>
                <div>
                  <img
                    src={MilestonesGif}
                    alt="milestones"
                    className="milestones-gif"
                  />
                  Milestones
                </div>
              </li>
            </a>

            <li className="theme-button-sm" ref={addToTiltRefs}>
              <div>
                <button onClick={() => handleOnlyThemeChange("dark")}>
                  <img src={MoonGif} alt="moon" className="theme-icon" />
                  {theme === "dark" && "Dark"}
                </button>
                <button onClick={() => handleOnlyThemeChange("light")}>
                  <img src={SunGif} alt="sun" className="theme-icon" />
                  {theme === "light" && "Light"}
                </button>
                <button onClick={() => handleOnlyThemeChange("system")}>
                  <img src={SystemGif} alt="system" className="theme-icon" />
                  {theme === "system" && "System"}
                </button>
              </div>
            </li>

            <div className="mclogo">
              <div className="pos">
                <img src={McLogoFull} alt="McLogoFull" className="mclogo" />
                <div>
                  <p>
                    &copy; 2024 Cheegiti Mahesh{" "}
                    <span role="img" aria-label="india">
                      🇮🇳
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </ul>
        </div>
      )}
    </>
  );
}
